export * from './HeadingDescription';
export { default as HeadingDescription } from './HeadingDescription';
